/*
 * @Description: vuex
 * @Author: 山淑兰
 * @Date: 2019-12-23 10:37:15
 * @LastEditTime: 2020-05-17 14:04:32
 * @LastEditors: 山淑兰
 */
import Vue from "vue";
import Vuex from "vuex";
import Cookie from "@/utils/cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    users: Cookie.get("RATINGS_USERS") || {
      name: "",
      isLogin: false,
    },
    meetingInfo: {},
  },
  mutations: {
    // 设置登陆信息
    SET_USERS(state, params) {
      Object.assign(state.users, params);
      Cookie.set("RATINGS_USERS", state.users, { expires: 1 });
    },
  },
  actions: {
    login: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        commit("SET_USERS", {
          ...params,
          isLogin: true,
        });
        resolve(params);
      });
    },
  },
  modules: {},
});
